<template>
    <UILink
        :href="router.resolve({ name: 'ViewRules' }).href"
        target="_blank"
    >
        <slot />
    </UILink>
</template>

<script setup lang="ts">
    import { useRouter } from 'vue-router';
    import UILink from '@/components/ui/UILink/UILink.vue';

    const router = useRouter();
</script>
